import React from 'react';
import { Navigate } from 'react-router-dom';
import { usuarioSignal } from '../../../signals/usuario';

const ProtectedRoute = ({ component: Component, funcionalidade }) => {
    if (funcionalidade) {
        const funcionalidades = Array.isArray(funcionalidade) ? funcionalidade : [funcionalidade];
        return funcionalidades.some((f) => usuarioSignal.value.rbac.temPermissao(f)) ? <Component /> : <Navigate replace to="/nao-autorizado" />;
    }
    return <Navigate replace to="/nao-autorizado" />;
};

export default ProtectedRoute;
